import { SpecificGameHttpResponse } from '@/interfaces/http-response/get-specific-game';
import SpecificGame from '@/models/specific-game';

export class SpecificGameAdapter {
    static adapt(data: SpecificGameHttpResponse): SpecificGame {
        return new SpecificGame(data);
    }
}
